
define('text!modules/campaign/bulkedit/creatives/templates/bin_title.html',[],function () { return '<div class="header-c title">\n<div class="include-bin-icon"></div> \n<span>selected {{bin_label}}</span> \n</div>';});

